import type { AdminViewDefinition } from "../../../components/admin-components.js";

export const storeDetailAdminViews: AdminViewDefinition[] = [
  storeOverviewView(),
  storeIntegrationHealthView(),
  storeJobsView(),
  storeUsageView(),
  storeAuditNotesView(),
  storeNotesView(),
];

export function storeOverviewView(): AdminViewDefinition {
  return storeView({
    id: "store-detail-overview",
    title: "Store overview",
    description:
      "Installed-store operational summary. No raw credentials or customer form content is shown.",
    cards: [],
  });
}

function storeIntegrationHealthView(): AdminViewDefinition {
  return storeView({
    id: "store-detail-integration-health",
    title: "Store integration health",
    description:
      "Inspect token metadata, scopes, webhooks, synchronization, storefront, offers, and extraction health.",
    actions: [],
    cards: [],
    callouts: [
      {
        title: "Credential safety",
        body: "A health refresh checks current status only. It does not display or rotate plaintext credentials and does not bypass  reauthorization requirements.",
      },
    ],
  });
}

function storeJobsView(): AdminViewDefinition {
  return storeView({
    id: "store-detail-jobs",
    title: "Store jobs",
    description:
      "Inspect sanitized store-scoped jobs, attempts, retry eligibility, and failure history.",
    actions: [],
    filters: ["Status", "Job type", "Queue", "Retryable"],
    tables: [],
  });
}

function storeUsageView(): AdminViewDefinition {
  return storeView({
    id: "store-detail-usage",
    title: "Store usage",
    description:
      "Review store-level operational volume, platform usage, and capacity without merchant commercial data.",
    actions: [],
    stats: [],
    cards: [],
    tables: [],
    callouts: [
      {
        body: "Usage is operational telemetry. It does not expose merchant product cost or pricing-margin details.",
        title: "Data boundary",
        tone: "blue",
      },
    ],
  });
}

function storeAuditNotesView(): AdminViewDefinition {
  return storeView({
    id: "store-detail-audit-notes",
    title: "Store audit",
    description: "Review immutable operational history for this store.",
    filters: ["Actor", "Action", "Result"],
    cards: [],
    tables: [],
    callouts: [
      {
        title: "Audit boundary",
        body: "Audit events are immutable and contain only admin-safe operational summaries.",
        tone: "orange",
      },
    ],
  });
}

function storeNotesView(): AdminViewDefinition {
  return storeView({
    id: "store-detail-notes",
    title: "Store notes",
    description: "Create and manage administrative notes for this store.",
    cards: [],
    tables: [],
    callouts: [
      {
        title: "Note safety",
        body: "Do not enter credentials, tokens, cookies, CSRF values, protected customer data, or raw provider payloads.",
        tone: "orange",
      },
    ],
  });
}

function storeView(input: Omit<AdminViewDefinition, "navId" | "tabs">): AdminViewDefinition {
  return {
    tabs: ["Overview", "Integration Health", "Jobs", "Usage", "Audit", "Notes"],
    actions: input.actions ?? [],
    ...input,
    navId: "installations",
  };
}
